import { RequestResponse } from '../../../../../core/application/http-response/http-response';
import {
  HttpClient,
  HttpMethod
} from '../../../../../core/application/protocols/http-client';
import { ServiceCommand } from '../../../../../core/domain/command/service-command';
import { error, success } from '../../../../../core/domain/either/either';

export class VerifyCnpjAvailability implements ServiceCommand<VerifyCnpjAvailability.Response> {
  constructor(
    private readonly httpClient: HttpClient<VerifyCnpjAvailability.Response>,
    private readonly url: string
  ) {}

  async execute(
    params: VerifyCnpjAvailability.Params
  ): Promise<ServiceCommand.Response<VerifyCnpjAvailability.Response>> {
    const httpResponse = await this.httpClient.request({
      method: HttpMethod.GET,
      url: `${this.url}/${params.cnpj}`
    });

    const responseOrError = RequestResponse.handle(httpResponse);

    if (responseOrError.isError()) {
      return error(responseOrError.value);
    }
    const response = responseOrError.value.response;

    return success(response);
  }
}

export namespace VerifyCnpjAvailability {
  export type Params = {
    cnpj: string;
  };

  export type Response = {
    exists: boolean;
    message: string;
  };
}
